import { Component } from '@angular/core';
import { CloudPimProductFieldsComponent } from 'gung-standard';

@Component({
    selector: 'cult-cloud-pim-product-fields',
    templateUrl: './cult-cloud-pim-product-fields.component.html',
    styleUrl: './cult-cloud-pim-product-fields.component.scss',
    standalone: false
})
export class CultCloudPimProductFieldsComponent extends CloudPimProductFieldsComponent {

}
